// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/settings/v1/system_management.proto" (package "c1.api.settings.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.settings.v1.SystemManagementConfig
 */
export interface SystemManagementConfig {
    /**
     * Global settings (shutoff semantics - false means enabled, true means disabled)
     *
     * @generated from protobuf field: bool notifications_shutoff = 1
     */
    notificationsShutoff: boolean;
    /**
     * @generated from protobuf field: bool bundle_automations_shutoff = 2
     */
    bundleAutomationsShutoff: boolean;
    /**
     * @generated from protobuf field: bool workflow_automations_shutoff = 3
     */
    workflowAutomationsShutoff: boolean;
    /**
     * Metadata
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
}
/**
 * Quota overrides response - wraps the TenantQuota data
 *
 * @generated from protobuf message c1.api.settings.v1.SystemManagementQuotaOverrides
 */
export interface SystemManagementQuotaOverrides {
    /**
     * Map of quota reference enum values to custom values
     *
     * @generated from protobuf field: map<int32, int64> quota_overrides = 1
     */
    quotaOverrides: {
        [key: number]: number;
    };
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetSystemManagementConfigRequest
 */
export interface GetSystemManagementConfigRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetSystemManagementConfigResponse
 */
export interface GetSystemManagementConfigResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SystemManagementConfig config = 1
     */
    config?: SystemManagementConfig;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateSystemManagementConfigRequest
 */
export interface UpdateSystemManagementConfigRequest {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SystemManagementConfig config = 1
     */
    config?: SystemManagementConfig;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.settings.v1.UpdateSystemManagementConfigResponse
 */
export interface UpdateSystemManagementConfigResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SystemManagementConfig config = 1
     */
    config?: SystemManagementConfig;
}
/**
 * Quota override methods
 *
 * @generated from protobuf message c1.api.settings.v1.GetSystemManagementQuotaOverridesRequest
 */
export interface GetSystemManagementQuotaOverridesRequest {
}
/**
 * @generated from protobuf message c1.api.settings.v1.GetSystemManagementQuotaOverridesResponse
 */
export interface GetSystemManagementQuotaOverridesResponse {
    /**
     * @generated from protobuf field: c1.api.settings.v1.SystemManagementQuotaOverrides quota_overrides = 1
     */
    quotaOverrides?: SystemManagementQuotaOverrides;
}
// @generated message type with reflection information, may provide speed optimized methods
class SystemManagementConfig$Type extends MessageType<SystemManagementConfig> {
    constructor() {
        super("c1.api.settings.v1.SystemManagementConfig", [
            { no: 1, name: "notifications_shutoff", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "bundle_automations_shutoff", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "workflow_automations_shutoff", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<SystemManagementConfig>): SystemManagementConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notificationsShutoff = false;
        message.bundleAutomationsShutoff = false;
        message.workflowAutomationsShutoff = false;
        if (value !== undefined)
            reflectionMergePartial<SystemManagementConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SystemManagementConfig): SystemManagementConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool notifications_shutoff */ 1:
                    message.notificationsShutoff = reader.bool();
                    break;
                case /* bool bundle_automations_shutoff */ 2:
                    message.bundleAutomationsShutoff = reader.bool();
                    break;
                case /* bool workflow_automations_shutoff */ 3:
                    message.workflowAutomationsShutoff = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SystemManagementConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool notifications_shutoff = 1; */
        if (message.notificationsShutoff !== false)
            writer.tag(1, WireType.Varint).bool(message.notificationsShutoff);
        /* bool bundle_automations_shutoff = 2; */
        if (message.bundleAutomationsShutoff !== false)
            writer.tag(2, WireType.Varint).bool(message.bundleAutomationsShutoff);
        /* bool workflow_automations_shutoff = 3; */
        if (message.workflowAutomationsShutoff !== false)
            writer.tag(3, WireType.Varint).bool(message.workflowAutomationsShutoff);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SystemManagementConfig
 */
export const SystemManagementConfig = new SystemManagementConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemManagementQuotaOverrides$Type extends MessageType<SystemManagementQuotaOverrides> {
    constructor() {
        super("c1.api.settings.v1.SystemManagementQuotaOverrides", [
            { no: 1, name: "quota_overrides", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ } }
        ]);
    }
    create(value?: PartialMessage<SystemManagementQuotaOverrides>): SystemManagementQuotaOverrides {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.quotaOverrides = {};
        if (value !== undefined)
            reflectionMergePartial<SystemManagementQuotaOverrides>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SystemManagementQuotaOverrides): SystemManagementQuotaOverrides {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<int32, int64> quota_overrides */ 1:
                    this.binaryReadMap1(message.quotaOverrides, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: SystemManagementQuotaOverrides["quotaOverrides"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SystemManagementQuotaOverrides["quotaOverrides"] | undefined, val: SystemManagementQuotaOverrides["quotaOverrides"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = reader.int64().toNumber();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.settings.v1.SystemManagementQuotaOverrides.quota_overrides");
            }
        }
        map[key ?? 0] = val ?? 0;
    }
    internalBinaryWrite(message: SystemManagementQuotaOverrides, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<int32, int64> quota_overrides = 1; */
        for (let k of globalThis.Object.keys(message.quotaOverrides))
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.Varint).int64(message.quotaOverrides[k as any]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.SystemManagementQuotaOverrides
 */
export const SystemManagementQuotaOverrides = new SystemManagementQuotaOverrides$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSystemManagementConfigRequest$Type extends MessageType<GetSystemManagementConfigRequest> {
    constructor() {
        super("c1.api.settings.v1.GetSystemManagementConfigRequest", []);
    }
    create(value?: PartialMessage<GetSystemManagementConfigRequest>): GetSystemManagementConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSystemManagementConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSystemManagementConfigRequest): GetSystemManagementConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSystemManagementConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSystemManagementConfigRequest
 */
export const GetSystemManagementConfigRequest = new GetSystemManagementConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSystemManagementConfigResponse$Type extends MessageType<GetSystemManagementConfigResponse> {
    constructor() {
        super("c1.api.settings.v1.GetSystemManagementConfigResponse", [
            { no: 1, name: "config", kind: "message", T: () => SystemManagementConfig }
        ]);
    }
    create(value?: PartialMessage<GetSystemManagementConfigResponse>): GetSystemManagementConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSystemManagementConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSystemManagementConfigResponse): GetSystemManagementConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.SystemManagementConfig config */ 1:
                    message.config = SystemManagementConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSystemManagementConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.SystemManagementConfig config = 1; */
        if (message.config)
            SystemManagementConfig.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSystemManagementConfigResponse
 */
export const GetSystemManagementConfigResponse = new GetSystemManagementConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSystemManagementConfigRequest$Type extends MessageType<UpdateSystemManagementConfigRequest> {
    constructor() {
        super("c1.api.settings.v1.UpdateSystemManagementConfigRequest", [
            { no: 1, name: "config", kind: "message", T: () => SystemManagementConfig },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<UpdateSystemManagementConfigRequest>): UpdateSystemManagementConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSystemManagementConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSystemManagementConfigRequest): UpdateSystemManagementConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.SystemManagementConfig config */ 1:
                    message.config = SystemManagementConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSystemManagementConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.SystemManagementConfig config = 1; */
        if (message.config)
            SystemManagementConfig.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateSystemManagementConfigRequest
 */
export const UpdateSystemManagementConfigRequest = new UpdateSystemManagementConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSystemManagementConfigResponse$Type extends MessageType<UpdateSystemManagementConfigResponse> {
    constructor() {
        super("c1.api.settings.v1.UpdateSystemManagementConfigResponse", [
            { no: 1, name: "config", kind: "message", T: () => SystemManagementConfig }
        ]);
    }
    create(value?: PartialMessage<UpdateSystemManagementConfigResponse>): UpdateSystemManagementConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSystemManagementConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSystemManagementConfigResponse): UpdateSystemManagementConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.SystemManagementConfig config */ 1:
                    message.config = SystemManagementConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSystemManagementConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.SystemManagementConfig config = 1; */
        if (message.config)
            SystemManagementConfig.internalBinaryWrite(message.config, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.UpdateSystemManagementConfigResponse
 */
export const UpdateSystemManagementConfigResponse = new UpdateSystemManagementConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSystemManagementQuotaOverridesRequest$Type extends MessageType<GetSystemManagementQuotaOverridesRequest> {
    constructor() {
        super("c1.api.settings.v1.GetSystemManagementQuotaOverridesRequest", []);
    }
    create(value?: PartialMessage<GetSystemManagementQuotaOverridesRequest>): GetSystemManagementQuotaOverridesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSystemManagementQuotaOverridesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSystemManagementQuotaOverridesRequest): GetSystemManagementQuotaOverridesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSystemManagementQuotaOverridesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSystemManagementQuotaOverridesRequest
 */
export const GetSystemManagementQuotaOverridesRequest = new GetSystemManagementQuotaOverridesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSystemManagementQuotaOverridesResponse$Type extends MessageType<GetSystemManagementQuotaOverridesResponse> {
    constructor() {
        super("c1.api.settings.v1.GetSystemManagementQuotaOverridesResponse", [
            { no: 1, name: "quota_overrides", kind: "message", T: () => SystemManagementQuotaOverrides }
        ]);
    }
    create(value?: PartialMessage<GetSystemManagementQuotaOverridesResponse>): GetSystemManagementQuotaOverridesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetSystemManagementQuotaOverridesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetSystemManagementQuotaOverridesResponse): GetSystemManagementQuotaOverridesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.settings.v1.SystemManagementQuotaOverrides quota_overrides */ 1:
                    message.quotaOverrides = SystemManagementQuotaOverrides.internalBinaryRead(reader, reader.uint32(), options, message.quotaOverrides);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetSystemManagementQuotaOverridesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.settings.v1.SystemManagementQuotaOverrides quota_overrides = 1; */
        if (message.quotaOverrides)
            SystemManagementQuotaOverrides.internalBinaryWrite(message.quotaOverrides, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.settings.v1.GetSystemManagementQuotaOverridesResponse
 */
export const GetSystemManagementQuotaOverridesResponse = new GetSystemManagementQuotaOverridesResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.settings.v1.SystemManagementService
 */
export const SystemManagementService = new ServiceType("c1.api.settings.v1.SystemManagementService", [
    { name: "GetSystemManagementConfig", options: { "authz.method": { role: "VIEWER" } }, I: GetSystemManagementConfigRequest, O: GetSystemManagementConfigResponse },
    { name: "UpdateSystemManagementConfig", options: { "authz.method": { role: "EDITOR" } }, I: UpdateSystemManagementConfigRequest, O: UpdateSystemManagementConfigResponse },
    { name: "GetSystemManagementQuotaOverrides", options: { "authz.method": { role: "VIEWER" } }, I: GetSystemManagementQuotaOverridesRequest, O: GetSystemManagementQuotaOverridesResponse }
]);
